import GetLabel from "foundation/js/getLabel"

export default {
    name: 'ActivityCard',
    props: {
        result: {
            type: Object,
            required: true
        },
        deleteCallback: {
            type: Function,
            required: false
        },
        hideStatus: {
            type: Boolean,
            required: false,
            default: false
        },
        hideEdit: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props) {
        const displayActionButtons = props.deleteCallback || props.result.editUrl 

        return {
            getLabel: (labelKey, params) => GetLabel({ labelKey, labelCollection: 'ActivityCard', params }),
            displayActionButtons
        }

    }
}
